<template>
  <v-flex
    id="otherMaterialNeeds"
    class="question"
  >
    <p class="mb-0 text-uppercase">
      {{ $t('sheet.sheet_two.hint') }}
    </p>
    <h2 class="header mb-0">
      {{ getOtherMaterialNeedsQuestions.label }}
    </h2>
    <ul class="questions-list">
      <li
        v-if="getOtherMaterialNeedsQuestions.hasOwnProperty('has_other_needs')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getOtherMaterialNeedsQuestions.has_other_needs.required }"
        >
          {{ getOtherMaterialNeedsQuestions.has_other_needs.label }}
        </p>
        <ConfirmButtons
          v-model="hasOtherNeeds"
          v-validate="{ required: getOtherMaterialNeedsQuestions.has_other_needs.required }"
          string
          :error-messages="errors.collect('hasOtherNeeds')"
          :data-vv-as="' '"
          :data-vv-name="'hasOtherNeeds'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="
          hasOtherNeeds === 'yes' &&
            getOtherMaterialNeedsQuestions.hasOwnProperty('selected_material_needs')
        "
        class="mt-4"
      >
        <p
          class="header custom lA mb-0"
          :class="{ required: getOtherMaterialNeedsQuestions.selected_material_needs.required }"
        >
          {{ getOtherMaterialNeedsQuestions.selected_material_needs.label }}
        </p>
        <p
          v-for="(text, index) in getOtherMaterialNeedsQuestions.selected_material_needs?.text"
          :key="index"
          class="mb-0"
        >
          <span v-html="text" />
        </p>
        <v-layout>
          <v-flex
            v-for="(item, index) in materialNeeds"
            :key="index"
            lg3
            xs6
          >
            <v-checkbox
              v-model="selectedMaterialNeeds"
              v-validate="{
                required: getOtherMaterialNeedsQuestions.selected_material_needs.required
              }"
              multiple
              :label="item.description"
              :value="item.id"
              :error="errors.has('selectedMaterialNeeds')"
              :error-messages="
                index + 1 === materialNeeds.length ? errors.collect('selectedMaterialNeeds') : null
              "
              :data-vv-as="' '"
              :data-vv-name="'selectedMaterialNeeds'"
              :disabled="readOnly"
            />
          </v-flex>
        </v-layout>
        <v-layout
          v-if="showFuelBlock"
          class="mt-4"
          wrap
        >
          <v-flex
            v-if="getOtherMaterialNeedsQuestions.hasOwnProperty('fuel_type')"
            lg4
          >
            <v-autocomplete
              v-model="fuelType"
              v-validate="{ required: getOtherMaterialNeedsQuestions.fuel_type.required }"
              :error-messages="errors.collect('fuelType')"
              :label="getOtherMaterialNeedsQuestions.fuel_type.label"
              :data-vv-as="$t('sheet.sheet_two.other_material_needs.labels.type')"
              data-vv-name="fuelType"
              :required="getOtherMaterialNeedsQuestions.fuel_type.required"
              append-icon="keyboard_arrow_down"
              :items="fuelList"
              item-value="id"
              item-text="description"
              :disabled="readOnly"
            />
          </v-flex>
          <v-flex
            v-if="getOtherMaterialNeedsQuestions.hasOwnProperty('fuel_amount')"
            lg4
          >
            <v-text-field
              v-model="fuelAmount"
              v-validate="{
                ...requiredRegularField(getOtherMaterialNeedsQuestions.fuel_amount.required)
              }"
              :error-messages="errors.collect('fuelAmount')"
              :data-vv-as="$t('sheet.sheet_two.other_material_needs.labels.amount')"
              data-vv-name="fuelAmount"
              :required="getOtherMaterialNeedsQuestions.fuel_amount.required"
              :class="[{ 'pl-2': $vuetify.breakpoint.mdAndUp }]"
              :label="$t('sheet.sheet_two.other_material_needs.labels.amount')"
              :disabled="readOnly"
            />
          </v-flex>
          <v-flex
            v-if="
              showOtherFuelType && getOtherMaterialNeedsQuestions.hasOwnProperty('other_fuel_type')
            "
            xs12
          >
            <p
              class="fw-600 mb-0"
              :class="{ required: getOtherMaterialNeedsQuestions.other_fuel_type.required }"
            >
              {{ getOtherMaterialNeedsQuestions.other_fuel_type.label }}
            </p>
            <v-text-field
              v-model="otherFuelType"
              v-validate="{
                ...requiredRegularField(getOtherMaterialNeedsQuestions.other_fuel_type.required)
              }"
              :error-messages="errors.collect('otherFuelType')"
              :data-vv-as="' '"
              data-vv-name="otherFuelType"
              :required="getOtherMaterialNeedsQuestions.other_fuel_type.required"
              :placeholder="$t('placeholders.add_text')"
              :disabled="readOnly"
            />
          </v-flex>
        </v-layout>
        <div
          v-if="
            showAnotherNeedsBlock &&
              getOtherMaterialNeedsQuestions.hasOwnProperty('another_material_needs')
          "
          class="mt-4"
        >
          <p
            class="fw-600 mb-0"
            :class="{ required: getOtherMaterialNeedsQuestions.another_material_needs.required }"
          >
            {{ getOtherMaterialNeedsQuestions.another_material_needs.label }}
          </p>
          <v-layout wrap>
            <v-flex
              v-for="(item, index) in anotherMaterialNeeds"
              :key="index"
              xs12
            >
              <v-layout align-center>
                <v-flex
                  class="mt-4 mr-2"
                  shrink
                >
                  <span class="fw-600 f-2 text-dark">{{ indexNum(index) }}</span>
                </v-flex>
                <v-flex md5>
                  <v-textarea
                    v-model="anotherMaterialNeeds[index]"
                    v-validate="{
                      ...requiredRegularField(
                        getOtherMaterialNeedsQuestions.another_material_needs.required
                      )
                    }"
                    :placeholder="$t('placeholders.add_text')"
                    :error-messages="errors.collect(createDataName('anotherMaterialNeeds', index))"
                    :data-vv-as="' '"
                    :data-vv-name="createDataName('anotherMaterialNeeds', index)"
                    :required="getOtherMaterialNeedsQuestions.another_material_needs.required"
                    :disabled="readOnly"
                    :rows="1"
                    auto-grow
                  />
                </v-flex>
                <v-flex
                  class="mt-2"
                  shrink
                >
                  <a
                    :disabled="!isCurrentEdition || readOnly"
                    @click="remove(index)"
                  >
                    <BaseIcon class="clickable ml-2 mt-1">
                      <CartIcon :icon-color="$vuetify.theme.sz_grey" />
                    </BaseIcon>
                  </a>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <a
                class="link_iconed"
                :disabled="!isCurrentEdition || readOnly"
                @click="add()"
              >
                <v-icon>add</v-icon> {{ $t('sheet.sheet_two.other_material_needs.add_btn') }}
              </a>
            </v-flex>
          </v-layout>
        </div>
      </li>
      <li
        v-if="
          hasOtherNeeds === 'yes' &&
            getOtherMaterialNeedsQuestions.hasOwnProperty('another_material_needs_notes')
        "
        class="mt-4"
      >
        <p
          class="fw-600 mb-0"
          :class="{
            required: getOtherMaterialNeedsQuestions.another_material_needs_notes.required
          }"
        >
          {{ getOtherMaterialNeedsQuestions.another_material_needs_notes.label }}
        </p>
        <v-textarea
          v-model="anotherMaterialNeedsNotes"
          v-validate="{
            ...requiredRegularField(
              getOtherMaterialNeedsQuestions.another_material_needs_notes.required
            )
          }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('anotherMaterialNeedsNotes')"
          :data-vv-as="' '"
          data-vv-name="anotherMaterialNeedsNotes"
          :disabled="readOnly"
          :rows="1"
          auto-grow
        />
      </li>
    </ul>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';
import CartIcon from '@/icons/CartIcon';
import BaseIcon from '@/icons/BaseIcon';

import validationRules from '@/constants/validationRules';
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

const { mapFields } = createHelpers({
    getterType: 'sheet/getOtherMaterialNeedsFields',
    mutationType: 'sheet/updateOtherMaterialNeeds'
});

export default {
    name: 'OtherMaterialNeeds',
    components: { ConfirmButtons, CartIcon, BaseIcon },
    mixins: [sheetResourcesGetter, sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules
        };
    },
    computed: {
        ...mapFields([
            'hasOtherNeeds',
            'selectedMaterialNeeds',
            'fuelType',
            'fuelAmount',
            'otherFuelType',
            'anotherMaterialNeeds',
            'anotherMaterialNeedsNotes'
        ]),
        fuelList () {
            return this.getSheetTwoResources(this.getOtherMaterialNeedsQuestions.fuel_type);
        },
        showOtherFuelType () {
            if (this.otherFuelTypeId && this.otherFuelTypeId.id === this.fuelType) {
                return true;
            }
            return false;
        },
        otherFuelTypeId () {
            return this.fuelList.find((el) => el.description === 'Inne');
        },
        showFuelBlock () {
            return this.selectedMaterialNeeds.includes(344);
        },
        showAnotherNeedsBlock () {
            return this.selectedMaterialNeeds.includes(345);
        },
        materialNeeds () {
            return this.getSheetTwoResources(this.getOtherMaterialNeedsQuestions.selected_material_needs);
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        ...mapGetters('sheet', ['getOtherMaterialNeedsQuestions'])
    },
    watch: {
        showAnotherNeedsBlock: function (val) {
            if (val && this.anotherMaterialNeeds.length === 0) {
                this.anotherMaterialNeeds.push(null);
            }
            if (val === false) {
                this.$nextTick(() => {
                    this.anotherMaterialNeeds = [];
                });
            }
        },
        showFuelBlock (val) {
            if (val === false) {
                this.fuelType = null;
                this.fuelAmount = null;
            }
        },
        hasOtherNeeds (val) {
            if (val === 'no') {
                this.$nextTick(() => {
                    this.selectedMaterialNeeds = [];
                    this.fuelType = null;
                    this.fuelAmount = null;
                    this.otherFuelType = null;
                    this.anotherMaterialNeeds = [];
                    this.anotherMaterialNeedsNotes = '';
                });
            }
        },
        showOtherFuelType (val) {
            if (val === false) {
                this.otherFuelType = null;
            }
        }
    },
    methods: {
        indexNum (index) {
            return index + 1 + '.';
        },
        createDataName (name, id) {
            return name + id;
        },
        add () {
            if (this.readOnly === true) {
                return;
            }
            this.anotherMaterialNeeds.push(null);
        },
        remove (index) {
            if (this.readOnly === true) {
                return;
            }
            if (this.anotherMaterialNeeds.length > 1) {
                this.anotherMaterialNeeds.splice(index, 1);
            }
        }
    }
};
</script>

<style scoped></style>
